import type { ReactElement } from 'react'
import { Trash2, ShieldCheck, Wrench, CalendarCheck, type LucideIcon } from 'lucide-react'
import { Card } from './ui/card.js'
import { Button } from './ui/button.js'
import { cn } from '@/lib/utils.js'
import type { AddOn } from '../lib/addons.js'

const ICON: Record<AddOn['iconKey'], LucideIcon> = {
  trash: Trash2,
  shield: ShieldCheck,
  wrench: Wrench,
  calendar: CalendarCheck,
}

interface Props {
  addon: AddOn
  selected: boolean
  onToggle: () => void
}

export const AddOnCard = ({ addon, selected, onToggle }: Props): ReactElement => {
  const Icon = ICON[addon.iconKey]
  return (
    <Card
      className={cn(
        'mb-3 p-4 transition-colors',
        selected ? 'border-primary bg-primary/5' : 'border-border',
      )}
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-accent text-accent-foreground flex items-center justify-center shrink-0">
          <Icon className="h-5 w-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-3">
            <div className="font-semibold">{addon.title}</div>
            <div className="text-primary font-semibold">${addon.priceUSD}</div>
          </div>
          {addon.recommended && addon.reason && (
            <div className="text-[10px] text-primary uppercase tracking-wider mt-1 font-semibold">{addon.reason}</div>
          )}
          <div className="text-sm text-muted-foreground mt-1">{addon.description}</div>
          <Button
            size="sm"
            variant={selected ? 'default' : 'outline'}
            onClick={onToggle}
            className="mt-3"
          >
            {selected ? 'Added' : 'Add'}
          </Button>
        </div>
      </div>
    </Card>
  )
}
